import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromSettingsDataStore from './state/settings-data-store.reducer';

/* effects */
import { SettingsDataStoreEffects } from './state/settings-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* SettingsDataStore State */
    StoreModule.forFeature(
      fromSettingsDataStore.featureKey,
      fromSettingsDataStore.reducer,
      { initialState: fromSettingsDataStore.initialState },
    ),
    EffectsModule.forFeature([SettingsDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class SettingsDataStoreModule {}
